// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Link: 'link',
	ChangePropertyTypeLink: 'change-property-type-link',
	ChangePropertyAddressLink: 'change-property-address-link',
	StartOrderButton: 'start-order-button',
	Button: 'button',
	Button1: 'button-1',
	OpenKeyDatesDrawerButton: 'open-key-dates-drawer-button',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
